var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details"},[_c('highlight-code',{attrs:{"lang":"json"}},[_vm._v(_vm._s(_vm.popupData))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }